// src/components/CompareBar.jsx
import React from "react";

export default function CompareBar({
  selectedCars = [], // array of up to 2 car objects
  onCompareClick = () => {}, // invoked only when ≥2 cars
  onClear = () => {}, // clear all selections
  onRemove = () => {}, // remove a single car
}) {
  console.log("selectedCars in compare bar component", selectedCars.length);

  return (
    <div className="fixed flex-col md:flex-row bottom-0 left-0 right-0 bg-accent text-white shadow-lg p-3 flex items-center justify-center gap-10 md:gap-40 z-50">
      <div className="flex items-center justify-center gap-5 md:gap-10 space-x-2">
        {selectedCars.map((car) => {
          const { base, extended } = car ?? {};

          const make = extended.make ?? extended.makeDvsa ?? "—";
          const model =
            extended.extModel ?? extended.model ?? extended.modelDvsa ?? "—";
          return (
            <div
              key={car.base.id}
              className="relative flex flex-col lg:flex-row items-center border-[1px] rounded-lg"
            >
              <button
                onClick={() => onRemove(car)}
                className="absolute -top-2 -right-2 bg-primary text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
              >
                ×
              </button>
              <img
                src={base.thumbnail || "/placeholder.jpg"}
                alt={`${make} ${model}`}
                className="w-full h-32 object-cover rounded"
              />
              <span className="w-full text-xs md:text-sm p-5 md:p-3">
                {make} {model}
              </span>
            </div>
          );
        })}
      </div>

      <div className="flex items-center space-x-6">
        <button
          onClick={onCompareClick}
          disabled={selectedCars.length < 2}
          className={`px-4 py-2 rounded ${
            selectedCars.length < 2
              ? "bg-customGray cursor-not-allowed"
              : "bg-primary"
          }`}
        >
          Compare
        </button>
        <button
          onClick={onClear}
          className="px-2 py-1 text-customGray hover:text-white"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
